import React, { PropsWithChildren } from 'react';

export function ContentCard({ children }: PropsWithChildren) {
  return <div className="content-card">{children}</div>;
}
